import { useQuery } from "@tanstack/react-query";
import { fetchSiteIdBySerial } from "./api";
import { queryKeys } from "../query";
import { TEXT_LIBRARY } from "../utils/constants";
import SnackbarUtils from "../components/Snackbar/utils";

function useFetchSiteId(serialNumber) {
  const {
    data = null,
    isLoading: loading,
    isError: error,
  } = useQuery({
    queryKey: queryKeys.fleet.detail(serialNumber),
    queryFn: async () => {
      const res = await fetchSiteIdBySerial(serialNumber);
      const record = Array.isArray(res?.data) ? res.data[0] : null;
      const id = record?.siteId || record?.systemId || null;
      const timezone = record?.timezone || "UTC";
      if (!id) {
        SnackbarUtils.error(TEXT_LIBRARY.NO_ACTIVE_SITEID_FOUND);
        return null;
      }
      return { siteId: id, timezone };
    },
    enabled: Boolean(serialNumber),
    staleTime: 10 * 60 * 1000, // siteId rarely changes — 10 min
    onError: () => {
      SnackbarUtils.error(TEXT_LIBRARY.ERROR_IN_FETCHING_SITEID);
    },
  });

  return {
    siteId: data?.siteId ?? null,
    timezone: data?.timezone ?? "UTC",
    loading,
    error,
  };
}

export default useFetchSiteId;
